import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { register } from '~/core/repository'
import '~/shared/tools/content/pipes'

export const $seeAllTitle = combine(i18n.$t, ({ t }) => t('see_all'))
export const $trailerTitle = combine(i18n.$t, ({ t }) => t('trailer'))
const $moreTitle = combine(i18n.$t, ({ t }) => t('more'))
const $descriptionTitle = combine(i18n.$t, ({ t }) => t('description'))
const $directorsTitle = combine(i18n.$t, ({ t }) => `${t('directors')}:`)
const $starsTitle = combine(i18n.$t, ({ t }) => `${t('stars')}:`)
const $alsoMayLikeTitle = combine(i18n.$t, ({ t }) => t('may_like'))
export const $liveLabel = combine(i18n.$t, ({ t }) => t('live'))
export const $detailsTitle = combine(i18n.$t, ({ t }) => t('details'))
export const $playTitle = combine(i18n.$t, ({ t }) => t('play'))
export const $emptyStateTitle = combine(i18n.$t, ({ t }) => t('no_content'))
export const $ok = combine(i18n.$t, ({ t }) => t('ok'))
export const $back = combine(i18n.$t, ({ t }) => t('back'))
export const $resume = combine(i18n.$t, ({ t }) => t('resume'))
export const $geoblockTitle = combine(i18n.$t, ({ t }) => t('geoblock_title'))

register($seeAllTitle, '$seeAllTitle')
register($trailerTitle, '$trailerTitle')
register($moreTitle, '$moreTitle')
register($descriptionTitle, '$descriptionTitle')
register($directorsTitle, '$directorsTitle')
register($starsTitle, '$starsTitle')
register($alsoMayLikeTitle, '$alsoMayLikeTitle')
register($detailsTitle, '$detailsTitle')
register($playTitle, '$playTitle')
register($emptyStateTitle, '$emptyStateTitle')
register($liveLabel, '$liveLabel')
register($seeAllTitle, '$seeAllTitle')
register($ok, '$ok')
register($back, '$back')
register($resume, '$resume')
register($geoblockTitle, '$geoblockTitle')
